import React from 'react'
import { useLocation } from 'react-router-dom'
import batIcon from '../../assets/bat.png'

const QuizTitle = ({ children, className = '' }) => {
  const location = useLocation()
  const isHalloween = !!location.pathname.includes('/halloween')

  return (
    <>
      {isHalloween ? (
        <div className='wrap-icons-text'>
          <div className='bat-image'>
            <img src={batIcon} alt='' />
          </div>
          <h2 className={`quiz-title ${className}`}>{children}</h2>
          <div className='bat-image reverse'>
            <img src={batIcon} alt='' />
          </div>
        </div>
      ) : (
        <h2 className={`quiz-title ${className}`}>{children}</h2>
      )}
    </>
  )
}

export default QuizTitle
